/**
 * Formats an ISO 8601 date string to US format with 12h time.
 * Example: "2026-04-14T14:10:55Z" → "04/14/2026, 2:10 PM"
 *
 * @param {string} value - ISO date string
 * @returns {string}
 */
export const formatDate = (value) => {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

/**
 * Formats a phone number to US standard: XXX-XXX-XXXX (no parentheses).
 *
 * @param {string} value - Raw phone number
 * @returns {string}
 */
export const formatPhone = (value) => {
  if (!value) return "-";
  const digits = value.trim().replace(/\D/g, "");

  if (digits.length === 10)
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;

  if (digits.length === 11 && digits[0] === "1")
    return `${digits.slice(1, 4)}-${digits.slice(4, 7)}-${digits.slice(7)}`;

  if (digits.length === 11)
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6, 10)}`;

  return value;
};